module.exports = __webpack_public_path__ + "static/img/win6.8e65b629.png";